const PLAN_TIER_EVENTS: Array<[tier: string, event: string]> = [
  ["starter", "purchase_starter"],
  // PRO+ (slug `pro-plus`, name `PRO+`) is the pro tier. Its slug contains
  // "plus", so it must be matched before the plus tier.
  ["pro-plus", "purchase_pro"],
  ["pro+", "purchase_pro"],
  ["plus", "purchase_plus"],
  ["pro", "purchase_pro"],
];

/**
 * Resolve the per-plan GA4 purchase event name from a plan slug (or name).
 * Returns null when the plan is not one of the paid tiers (e.g. free).
 */
export function purchaseEventName(
  planSlug: string | null | undefined,
): string | null {
  if (!planSlug) return null;
  const slug = planSlug.toLowerCase();
  for (const [tier, event] of PLAN_TIER_EVENTS) {
    if (slug.includes(tier)) return event;
  }
  return null;
}
